import React, { useState } from "react";
import Button from '@mui/material/Button';
import { amplify } from "../../service/api/AuthService";
import { useHistory } from "react-router-dom";

const ChangePassError = () => {


  const handleClickSignOut = () => {
    amplify.signOut();
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => {
    setModalOpen(false);
  }

  let history = useHistory();
  const redirect = () => {
    history.push({
      pathname: `/score`,
    })
  }

  return (
    <>
      {(
        <div
          open={modalOpen}
          onClose={handleCloseModal}
          className="modal-container">
          <div className="pop-up-modal-error col-xl-5">

            <div className="row mt-5 pt-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
                <path fill="#FF1524" fillRule="evenodd" d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zM32.686 29.858L44 41.172l11.314-11.314c.78-.781 2.047-.781 2.828 0 .781.78.781 2.047 0 2.828L46.828 44l11.314 11.314c.781.78.781 2.047 0 2.828-.78.781-2.047.781-2.828 0L44 46.828 32.686 58.142c-.78.781-2.047.781-2.828 0-.781-.78-.781-2.047 0-2.828L41.172 44 29.858 32.686c-.781-.78-.781-2.047 0-2.828.78-.781 2.047-.781 2.828 0z" />
              </svg>
            </div>

            <div className="col-8 offset-2 text-center mt-4">
              <h2>Algo ha salido mal</h2>
            </div>

            <div className="row">
              <div className="col-6 mx-auto text-center mt-4">
                <p>No hemos podido actualizar tu contraseña. Por favor, inténtalo
                  de nuevo más tarde.</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
            <Button onClick={redirect}>
                <span className="btn-volver col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5 me-3">Volver a intentar</span>
              </Button>

              <Button onClick={handleClickSignOut}>
                <span className="btn-inicio col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5 ms-3">Ir al inicio</span>
              </Button>

            </div>

          </div>
        </div >
      )}
    </>
  );
}

export default ChangePassError;
